import React from 'react'

import cl from 'classnames'

import { Layout } from 'components/layout'

import { MenusApi, Menu } from '@services/api/menus'
import { HeadMetadata } from 'components/head-metadata'

import { SearchApi } from '@services/api/search-page'
import { GetServerSideProps } from 'next'
import { Pagination } from '@components/shared/pagination'
import useSWR from 'swr'
import { fetcherDataApi } from '@utils/fetcher-data-api'
import { createUrlParamsSwr } from '@utils/create-url-params-swr'

import { SearchIndexDto } from '@services/api/search-page/types'
import { SearchedItem } from '@components/resultado-pesquisa/searched-item'
import { Divider } from '@components/resultado-pesquisa/divider'

interface Props {
  main: Menu[]
  footer1: Menu[]
  footer2: Menu[]
  initialData: SearchIndexDto
  url: string
  queryParams: any
}

const SearchPage = ({
  main,
  footer1,
  footer2,
  initialData,
  url,
  queryParams
}: Props) => {
  const { data } = useSWR<SearchIndexDto>(url, fetcherDataApi, { initialData })
  const { searches, meta: pagination } = data

  const message =
    pagination?.totalCount > 0
      ? `Encontramos essas matérias relacionadas à sua busca:`
      : 'Desculpe, não encontramos nada relacionado à sua busca.'

  return (
    <Layout
      sponsorKeyword="home"
      mainMenus={main}
      footerMenus1={footer1}
      footerMenus2={footer2}
      logoUrl="/noticias"
    >
      <HeadMetadata
        title="Resultado da Pesquisa"
        metaTitle="Resultado da Pesquisa"
        metaDescription="Registros encontrados relacionados à busca"
      />
      <div className="search-result">
        <h2
          className={cl('md:text-2xl sm:text-2xl font-firaSans md:mx-4 my-4', {
            'text - orange': pagination?.totalCount === 0
          })}
        >
          {message} {pagination?.totalCount > 0 && <b>{queryParams.q}</b>}
        </h2>
        <div className="grid grid-cols-1 gap-y-5 mt-10">
          {searches?.map(article => {
            return (
              <>
                <SearchedItem key={article.id} {...article} />
                <Divider />
              </>
            )
          })}
        </div>

        {pagination && searches && searches.length > 0 && (
          <Pagination
            currentPage={pagination.currentPage}
            pageSize={pagination.per}
            total={pagination.totalCount}
            queryParams={queryParams}
          />
        )}
      </div>
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  const menus = await MenusApi.all()

  const SEARCH_PER_PAGE = 16
  const q = query.q ? String(query.q) : ''
  const { data: initialData } = await SearchApi.index({
    q,
    page: query.page && Number(query.page),
    per: SEARCH_PER_PAGE
  })

  return {
    props: {
      ...menus,
      initialData,
      ...createUrlParamsSwr({
        query,
        per: SEARCH_PER_PAGE,
        path: '/search',
        params: { q }
      }),
      queryParams: {
        q
      }
    }
  }
}

export default SearchPage
